import { computed } from "nanostores";

import type {
  GetQueryActionData,
  GetQueryActionResponse,
  ListQueryActionData,
  ListQueryActionResponse,
} from "../api/types.gen.ts";

import { getQueryAction, listQueryAction } from "../api";
import { createApiStore } from "./api-store";
import { $router } from "./router";

/** List (all); page size 1 is enough to read `totalItems` from the paginated response. */
export const $queryActionsList = createApiStore<
  ListQueryActionResponse,
  ListQueryActionData
>(listQueryAction, {
  mapToOptions: () => ({
    query: {
      currentPage: 1,
      pageSize: 1,
    },
  }),
  params: [computed($router, (r) => String(r?.route ?? ""))],
  storeKey: "queryActionsList",
});

/** Enrichment tools only; page size 1 is enough to read `totalItems`. */
export const $enrichmentQueryActionsList = createApiStore<
  ListQueryActionResponse,
  ListQueryActionData
>(listQueryAction, {
  mapToOptions: () => ({
    query: {
      currentPage: 1,
      pageSize: 1,
      type: "enrichment" as const,
    },
  }),
  params: [computed($router, (r) => String(r?.route ?? ""))],
  storeKey: "enrichmentQueryActionsList",
});

export const $queryActionContent = createApiStore<
  GetQueryActionResponse,
  GetQueryActionData
>(getQueryAction, {
  mapToOptions: ([queryActionId]) => ({
    path: {
      queryActionId: queryActionId || "",
    },
  }),
  params: [
    computed($router, (route) =>
      route?.route === "queryActionEdit" ? route.params.queryActionId : null,
    ),
  ],
  storeKey: "queryActionContent",
});
